<template>
  <div class="Main Site">
    <van-nav-bar
      fixed
      :border="false"
      :title="navBarTitle"
      :left-arrow="$route.name=='user'?false:true"
      :right-text="rightText"
      @click-left="onClickLeft"
      @click-right="onClickRight"
      v-if="$route.name!='user'&&$route.name!='promote'"
      :style="$route.name=='promote'?'background:transparent':''"
    />
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'UserCenter',
  components: {
  },
  props: [],
  data() {
    return {
      rightText: '',
      navBarTitle: '',
    }
  },
  computed: {

  },
  watch: {
    $route(to,from){
      switch(to.name) {
        case 'postRecord':
          this.rightText = this.$t('postTask.navBar.title')
          break;
        case 'bankCard':
          this.rightText = this.$t('bankCard.default[4]')
          break;
        default:
          this.rightText = ''
      }
    }
  },
  created() {
    switch(this.$route.name) {
      case 'postRecord':
        this.rightText = this.$t('postTask.navBar.title')
        break;
      case 'bankCard':
        this.rightText = this.$t('bankCard.default[4]')
        break;
      default:
        this.rightText = ''
    }
  },
  mounted() {

  },
  activated() {

  },
  destroyed() {
    
  },
  methods: {
    onClickLeft() {
      switch(this.$route.name) {
        case 'taskRecord':
        case 'postRecord':
        case 'auditRecord':
          this.$router.push('/user')
          break;
        case 'recharge':
          if(this.$children[1].showPrice){
            this.$children[1].showPrice = false
          }else{
            this.$router.go(-1)
          }
          break;
        case 'bankCard':
          if(this.$children[1].showAdd){
            this.$children[1].showAdd = false
          }else{
            this.$router.go(-1)
          }
          break;
        default:
          this.$router.go(-1)
      }
    },
    onClickRight() {
      if(this.$route.name=='postRecord'){
        this.$router.push('/user/postTask')
      }
      if(this.$route.name=='bankCard'){
        this.$children[1].showAdd = true
      }
    }
  }
}
</script>
<style scoped>

</style>